// extracted by mini-css-extract-plugin
export default {"loader":"Body_loader__WlbsY","fullRow":"Body_fullRow__snBIm","notFound":"Body_notFound__s54yG"};